import { Redirect } from "react-router-dom";
import Api from "../Api";

//url for production
export var url = "";
if (process.env.NODE_ENV === "development") {
  url = "";
} else {
  url = window.location.host.split("/")[1];
  if (url) {
    url = `/${window.location.host.split("/")[1]}`;
  } else url = process.env.PUBLIC_URL; /// ADD YOUR CPANEL SUB-URL
}

//Function to validate and return errors for a form
export const checkForm = (formData) => {
  let errorState = {};
  Object.keys(formData).forEach((item) => {
    if (formData[item] === null || formData[item] === "") {
      errorState[item] = "This field is required";
    }
  });
  return errorState;
};

//Function that returns the first or first two letters from a name
export const findUpper = (string) => {
  let extractedString = [];

  for (var i = 0; i < string.length; i++) {
    if (string.charAt(i) === string.charAt(i).toUpperCase() && string.charAt(i) !== " ") {
      extractedString.push(string.charAt(i));
    }
  }
  if (extractedString.length > 1) {
    return extractedString[0] + extractedString[1];
  } else {
    return extractedString[0];
  }
};

//Function that calculates the from current date
export const setDeadline = (days) => {
  let todayDate = new Date();
  var newDate = new Date(todayDate);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
};

// Function to set deadline for projects
export const setDeadlineDays = (deadline) => {
  var currentDate = new Date();
  var difference = deadline.getTime() - currentDate.getTime();
  var days = Math.ceil(difference / (1000 * 3600 * 24));
  return days;
};

//Date formatter function
export const dateFormatterAlt = (date, reverse) => {
  let d = date.getDate();
  let m = date.getMonth();
  let y = date.getFullYear();
  reverse ? (date = m + "-" + d + "-" + y) : (date = y + "-" + d + "-" + m);
  return date;
};

//Date formatter function
export const dateFormatter = (date, reverse) => {
  var dateformat = date.split("-");
  //var date = dateformat[1]+"-"+dateformat[2]+"-"+dateformat[0];
  reverse
    ? (date = dateformat[2] + "-" + dateformat[0] + "-" + dateformat[1])
    : (date = dateformat[1] + "-" + dateformat[2] + "-" + dateformat[0]);
  return date;
};

//Month Names
export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

//todays Date
export const todaysDate = new Date();

// Function to structure date ex : Jun 4, 2011;
export const getDateStructured = (date) => {
  let d = date.getDate();
  let m = date.getMonth();
  let y = date.getFullYear();
  let final = monthNames[m] + " " + d + ", " + y;
  return final;
};

// Function to structure date ex: YYYY-MM-DD
export const setDateForPicker = (rdate) => {
  let d = rdate.getDate();
  d < 10 && (d = "0" + d);
  let m = rdate.getMonth() + 1;
  m < 10 && (m = "0" + m);
  let y = rdate.getFullYear();
  rdate = y + "-" + m + "-" + d;

  return rdate;
};

//current Time
export const currentTime = () => {
  var hours = todaysDate.getHours();
  var minutes = todaysDate.getMinutes();
  var ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
};

//Percentage calculation
export const calcPercentage = (str1, str2) => {
  let result = Number(str2) / Number(str1);
  result = result * 100;
  return Math.floor(result);
};

//shortens a long string
export const truncate = (str, n) => {
  return str.length > n ? str.substr(0, n - 1) + " " + truncate(str.substr(n - 1, str.length), n) : str;
};

export const RedirectAs404 = ({ location }) => (
  <Redirect to={Object.assign({}, location, { state: { is404: true } })} />
);

// returns upload url
export const getUploadParams = () => {
  return { url: "https://httpbin.org/post" };
};

// Converts KB to MB
export const bytesToMegaBytes = (bytes) => {
  let result = bytes / (1024 * 1024);
  return result.toFixed(2);
};

export const bulkActionOptions = [
  { value: "suspend", label: "Suspend User" },
  { value: "delete", label: "Delete User" },
];


export const generateToken = async (formData) => {
  const token = await Api.AuthToken(formData);
  if (token.message === "token generate.") {
    const login = await Api.ClientLogin(formData, token.data.access_token);

    localStorage.setItem("tokenAdmin", JSON?.stringify(token));
    localStorage.setItem("formCd", JSON?.stringify(formData));
    localStorage.setItem("countsAdmin", Date.now());
    localStorage?.setItem("userTypeId", login?.data?.userTypeId);
    localStorage?.setItem("formDataUsername", login?.data?.userName);
    localStorage.setItem("accessToken", "token");
    localStorage?.setItem("gettenantId", login?.data?.tenantId);

    setTimeout(() => {
      window.history.pushState(
        `${process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/manage-users` : `${process.env.PUBLIC_URL}/manage-users`}`,
        "auth-login",
        `${process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/manage-users` : `${process.env.PUBLIC_URL}/manage-users`}`
      );
      window.location.reload();
    }, 2000);
    return ""
  } else {
    return token.message
  }
}

export const tenantAddEditData = {
  name: "",
  organizationName: "",
  contactName: "",
  firstName: "",
  middleName: "",
  lastName: "",
  emailId: "",
  streetAddress: "",
  city: "",
  state: "",
  zip: "",
  country: "",
  createdBy: "",
  isActive: true,
  phoneNo: "",
  tenantHost: [
    {
      hostUrl: "https://localhost:44365",
      hostIp: "192.168.1.41",
      createdBy: "TestDv",
      isActive: true
    }
  ],
  tenantLicense: [
    {
      tenantId: 1,
      serviceStartDate: "2022-08-26T00:00:00.000Z",
      createdBy: "TestDv",
      isActive: true
    }
  ],
  tenantPhone: [
    {
      phoneNo: "(+1) 999 999 9999",
      createdBy: "TestDv",
      isActive: true
    }
  ],
  tenantSecret: [
    {
      applicationName: "RingConnect",
      apiKey: "AC2125f886cdeade6af4013e5b66d92cd0",
      apiSecret: "8db40d652e8a3fda7de78190fd0328bb",
      createdBy: "TestDv",
      isActive: true
    }
  ]
}

export const GetTenantIdUp = () => {
  return localStorage?.getItem("gettenantId") ? JSON?.parse(localStorage?.getItem("gettenantId")) : "";
}

export const urlTenantID = () => {
  return sessionStorage?.getItem("tempTenantId") ? JSON?.parse(sessionStorage?.getItem("tempTenantId")) : "";
}

export const SetTenantIdUp = (id) => {
  // localStorage?.setItem("gettenantId", JSON?.stringify(id));
}

export const formateDateTenant = (inDate) => {
  const formattedDate = inDate.toISOString();
  return formattedDate;
}

export const timeStamp = () => {
  const now = new Date();
  const year = now.getUTCFullYear();
  const month = ('0' + (now.getUTCMonth() + 1)).slice(-2); // Months are zero-indexed, so we add 1
  const day = ('0' + now.getUTCDate()).slice(-2);
  const hours = ('0' + now.getUTCHours()).slice(-2);
  const minutes = ('0' + now.getUTCMinutes()).slice(-2);
  const seconds = ('0' + now.getUTCSeconds()).slice(-2);
  const milliseconds = ('00' + now.getUTCMilliseconds()).slice(-3);
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
}

export const formDataUsername = () => localStorage?.getItem("formDataUsername") || "";

export const getFormUserMail = () => localStorage?.getItem("UserLoginEmail") || "";

export const LoginUserfirstName = () => localStorage?.getItem("LoginUserfirstName") || "";

export const userTypeId = () => localStorage?.getItem('userTypeId') || "";

export const getFileTypeFromDataURL = (dataURL) => {
  const matches = dataURL.match(/^data:(.*?);base64,/);
  if (matches && matches.length > 1) {
    return matches[1]?.split("/")?.[1]; // This will return 'image/png' in your example
  }
  return null; // Handle case where file type couldn't be extracted
};

export const formatDates = (date) => {
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
  const year = date.getFullYear();
  return `${month}-${day}-${year}`;
};

// export const nameRegex = /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/;
export const nameRegex = /^[a-zA-Z-' ]+$/;
export const numberRegex = /^\d+$/;
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()\-_=+{};:,<.>]).{8,16}$/;
export const domainRegex = /^[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z]{2,})+$/;
export const zipCodeRegex = /^\d{5}$/;
export const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
export const usaNumRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
export const usaNumRegex2 = /^\+1\(\d{3}\) \d{3}-\d{4}$/;
export const usaNumRegex3 = /^\+\d{11}$/;
export const indianNumRegex = /^\+\d+\(\d{3}\) \d{3}-\d{3,4}[^\d]*$/;
export const domainPattern = /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
export const ipPattern = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
export const domainRegexs = /^[A-Za-z0-9]+$/;

export const extractError = (err) => {
  const regex = /Error :: Code : \d+ :: (.+?)\r\n/;
  const match = err.match(regex);
  if (match) {
    const errorMessage = match[1];
    return errorMessage;
  } else {
    return "";
  }
}